import React, { useState } from "react";
import {
  Box, Grid2 as Grid, Paper, Typography, useTheme, useMediaQuery
} from "@mui/material";
import GraficoTraffico from "../Dashboard/GraficoTraffico";
import GraficoClick from "../Dashboard/GraficoClick";
import GraficoCategorie from "../Dashboard/GraficoCategorie";
import GraficoRegistrazioni from "../Dashboard/GraficoRegistrazioni";
import Notifiche from "./Notifiche";
import FiltroTemporale from "../Dashboard/FiltroTemporale";
import AdminPageHeader, { adminPageShellSx } from "../Shared/AdminPageHeader";

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Stato globale per i filtri temporali
  const [filtro, setFiltro] = useState("ultimo_anno");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  return (
    <Box sx={adminPageShellSx}>
      <AdminPageHeader
        title="Dashboard"
        subtitle="Panoramica delle statistiche e dei dati principali della piattaforma"
        actions={(
          <FiltroTemporale
            filtro={filtro}
            setFiltro={setFiltro}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        )}
      />

      {/* Sezione grafici */}
      <Grid container spacing={isMobile ? 2 : 4} sx={{ mb: 5 }}>
        {/* RIGA 1: Prodotti e Categorie */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="subtitle1" sx={{ color: "#0b3d87", fontWeight: 800, mb: 1, ml: 1, textTransform: "uppercase", fontSize: "0.85rem", letterSpacing: "0.5px" }}>
            Prodotti Più Cliccati
          </Typography>
          <Paper elevation={3} sx={{ p: isMobile ? 2 : 3, height: isMobile ? "400px" : "380px", display: "flex", flexDirection: "column", borderRadius: "20px", border: "1px solid #e2e8f0" }}>
            <GraficoClick
              filtroTempoGlobal={filtro}
              startDateGlobal={startDate}
              endDateGlobal={endDate}
            />
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="subtitle1" sx={{ color: "#0b3d87", fontWeight: 800, mb: 1, ml: 1, textTransform: "uppercase", fontSize: "0.85rem", letterSpacing: "0.5px" }}>
            Categorie più cliccate
          </Typography>
          <Paper elevation={3} sx={{ p: isMobile ? 2 : 3, height: isMobile ? "400px" : "380px", display: "flex", flexDirection: "column", borderRadius: "20px", border: "1px solid #e2e8f0" }}>
            <GraficoCategorie
              filtroTempoGlobal={filtro}
              startDateGlobal={startDate}
              endDateGlobal={endDate}
            />
          </Paper>
        </Grid>

        {/* RIGA 2: Traffico e Registrazioni */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="subtitle1" sx={{ color: "#0b3d87", fontWeight: 800, mb: 1, ml: 1, textTransform: "uppercase", fontSize: "0.85rem", letterSpacing: "0.5px" }}>
            Statistiche Traffico
          </Typography>
          <Paper elevation={3} sx={{ p: isMobile ? 2 : 3, height: isMobile ? "400px" : "380px", display: "flex", flexDirection: "column", borderRadius: "20px", border: "1px solid #e2e8f0" }}>
            <GraficoTraffico
              filtroGlobal={filtro}
              startDateGlobal={startDate}
              endDateGlobal={endDate}
            />
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="subtitle1" sx={{ color: "#0b3d87", fontWeight: 800, mb: 1, ml: 1, textTransform: "uppercase", fontSize: "0.85rem", letterSpacing: "0.5px" }}>
            Statistiche Registrazioni
          </Typography>
          <Paper elevation={3} sx={{ p: isMobile ? 2 : 3, height: isMobile ? "400px" : "380px", display: "flex", flexDirection: "column", borderRadius: "20px", border: "1px solid #e2e8f0" }}>
            <GraficoRegistrazioni
              filtroGlobal={filtro}
              startDateGlobal={startDate}
              endDateGlobal={endDate}
            />
          </Paper>
        </Grid>
      </Grid>

      <Notifiche />

    </Box>
  );
};

export default Dashboard;
